<template>
    <component :is="inDialog ? 'div' : BaseCard" v-bind="inDialog ? {} : { padding: 'lg' }" class="flex flex-col items-center text-center" :class="inDialog ? 'gap-4' : 'gap-5'">
        <ReflectionIcon kind="self" size="md" />
        <div class="flex flex-col gap-2 max-w-xl">
            <h2 v-if="!inDialog" class="display-serif text-ink">{{ hideStart ? t("reflections.self.howItWorksTitle") : "Start a self reflection" }}</h2>
            <p class="body-small text-ink-muted">Check in with yourself — your progress, your challenges, your next step. Your answers shape the coaching you get.</p>
        </div>

        <BaseButton v-if="!inDialog && !hideStart" type="button" theme="primary" size="sm" class="whitespace-nowrap" @click="emit('start')">Launch</BaseButton>
    </component>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";
import { useI18n } from "vue-i18n";

defineProps<{ inDialog?: boolean; hideStart?: boolean }>();
const { t } = useI18n();

const emit = defineEmits<{ (event: "start"): void }>();
</script>
